<svg
  [attr.width]="width()"
  [attr.height]="height()"
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  [attr.stroke-width]="strokeWidth()"
  stroke-linecap="round"
  stroke-linejoin="round">
  <polyline points="6 9 12 15 18 9"></polyline>
</svg>
